var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 86,
    fill: "#FF5B5B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 98.5,
    stroke: "#FF5B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 89.7273V99C131 107.607 127.629 115.862 121.627 121.949C115.626 128.035 107.487 131.455 99 131.455M99 131.455C90.5131 131.455 82.3737 128.035 76.3726 121.949C70.3714 115.862 67 107.607 67 99V89.7273M99 131.455V150M80.7143 150H117.286M99 48C95.3627 48 91.8745 49.4654 89.3025 52.0739C86.7306 54.6823 85.2857 58.2202 85.2857 61.9091V99C85.2857 102.689 86.7306 106.227 89.3025 108.835C91.8745 111.444 95.3627 112.909 99 112.909C102.637 112.909 106.126 111.444 108.697 108.835C111.269 106.227 112.714 102.689 112.714 99V61.9091C112.714 58.2202 111.269 54.6823 108.697 52.0739C106.126 49.4654 102.637 48 99 48Z",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultMic);
export default __webpack_public_path__ + "static/media/DefaultMic.60c00cf4599132e0bfafbff660668316.svg";
export { ForwardRef as ReactComponent };